import merge from "lodash/merge";
import omitBy from "lodash/omitBy";
import browserRequest from "superagent";
import config from "../config";
import logger from "../logger";

import GlobalNotificationActions from "../actions/GlobalNotificationActions";

import UserStore from "../stores/UserStore";
import UserActions from "../actions/UserActions";
import { history } from "../util";

// Cache for pending requests to prevent duplicate simultaneous requests
const pendingRequests = new Map();

// Generate a unique key for request deduplication
function generateRequestKey(opts) {
  const keyComponents = {
    method: opts.method,
    endpoint: opts.endpoint,
    qs: opts.qs,
    json: opts.json,
    api_key: opts.api_key,
    godCredentials: opts.godCredentials,
    allow_cache: opts.allow_cache,
    getText: opts.getText
  };

  // Remove any undefined or null values to ensure consistent key generation
  Object.keys(keyComponents).forEach(key => {
    if (keyComponents[key] === undefined || keyComponents[key] === null) {
      delete keyComponents[key];
    }
  });

  return JSON.stringify(keyComponents);
}

function request(opts, cb) {
  // Only deduplicate GET requests to avoid side effects with other HTTP methods
  const shouldDedupe = opts.method && opts.method.toLowerCase() === "get";

  // Generate a unique key for this request
  const requestKey = generateRequestKey(opts);

  if (shouldDedupe) {
    // Check if an identical request is already pending
    if (pendingRequests.has(requestKey)) {
      // Return the existing pending request
      const pendingRequest = pendingRequests.get(requestKey);
      pendingRequest.then(
        result => cb(null, result),
        error => cb(error)
      );
      return;
    }
  }

  // Create a new promise for this request
  const requestPromise = new Promise((resolve, reject) => {
    var qs = omitBy(opts.qs, k => k === null || k === undefined);
    if (Object.keys(qs).length === 0) {
      qs = undefined;
    }

    if (opts.method.toLowerCase() === "delete") {
      opts.method = "del";
    }

    var req = browserRequest[opts.method.toLowerCase()](
      config.endpoint + opts.endpoint
    );

    req.query(qs);

    if (opts.api_key) {
      req.auth(opts.api_key);
    }

    // God mode authentication
    if (opts.godCredentials) {
      req.auth(opts.godCredentials.apiKey, opts.godCredentials.activeUser);
    } else if (
      UserStore &&
      UserStore.isLoggedIn() &&
      UserStore.isGodInAnyForm()
    ) {
      let credentials = UserStore.getGodCredentials();
      req.auth(credentials.apiKey, credentials.activeUser);
    }

    // Single file upload
    if (opts.file) {
      req.attach(opts.fileField, opts.file, opts.file.name);
    }

    // Multi-file upload
    if (opts.files) {
      opts.files.forEach(f => {
        req.attach(f.field, f.file, f.file.name);
      });
    }

    // Bypass cache
    if (!opts.allow_cache) {
      req.set("x-apicache-bypass", true);
    }

    if (opts.json) {
      var data = merge(opts.json, { event_bucket: config.event_bucket });
      if (opts.file || opts.files) {
        // If multipart, include data as fields
        Object.keys(data).forEach(k => {
          req.field(k, data[k]);
        });
      } else {
        req.send(data);
      }
    }

    req.end(function (err, resp) {
      // Remove from pending requests cache when complete (only for GET requests)
      if (shouldDedupe) {
        pendingRequests.delete(requestKey);
      }

      if (resp && resp.body && resp.body.error) {
        // Disable logging of errors... tooooo maannyyy.
        // let errorToLog = Object.assign({}, body.error, {
        //   error_source: 'api-response-error',
        //   request: opts
        // });
        // logger.info(errorToLog);

        // Redirect to login page for invalid credentials
        if (
          (!opts.ignoreLoginErrors &&
            resp.body.error.code === "InvalidCredentials") ||
          ((resp.body.error.code === "BadRequestError" ||
            resp.body.error.code === "BadRequest") &&
            resp.body.error.message.indexOf(
              "An API key or token must be specified"
            ) !== -1)
        ) {
          if (window.location.href.indexOf("login") === -1) {
            UserActions.logout();
            UserActions.loginFailed(resp.body.error);
            history.push("/login");
          }
          reject(resp.body.error);
          return;
        }

        reject(resp.body.error);
        return;
      }

      if (err && err.message.indexOf("Request has been terminated") === 0) {
        GlobalNotificationActions.notify(
          "Network connection lost. Please reconnect and try again."
        );
        reject(err);
        return;
      }

      if (resp && opts.getText) {
        resolve(resp && resp.xhr.response);
        return;
      }

      resolve(resp && resp.body);
    });
  });

  // Store the promise in the cache (only for GET requests)
  if (shouldDedupe) {
    pendingRequests.set(requestKey, requestPromise);
  }

  // Execute the callback with the promise result
  requestPromise.then(
    result => cb(null, result),
    error => cb(error)
  );
}

export default {
  request: request
};



// WEBPACK FOOTER //
// ./src/app/utils/api.js